import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingGetNextDocumentNumberAtom = createMutationAtomFactory(
  'trade.bookingGetNextDocumentNumber',
  (params: { facilityId: string }) => ({
    tradeBookingNextDocumentNumber: {
      __args: { facilityId: params.facilityId },
    },
  }),
);
